import React, {useEffect, useState} from "react";


// components
import {GenericButton} from "../../../components/buttons/customButtons";
import {showToastCustom} from "../../../components/toast/customToast";
import LoadingComponent from "./components/LoadingComponent";
import MetricDataComponent from "./components/MetricDataComponent";
import NotInfoComponent from "./components/NotInfoComponent";
import MetricGraphicComponent from "./components/MetricGraphicComponent";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import TranslateStatisticsDetails from "./TranslateStatisticsDetails";

// labels
import {LB_CALCULATING_METRICS, LB_LOADING, LB_UPDATE_METRICS} from "../../../components/i18n/i18n";

// services
import {applicativeService} from "../../../jwt/_services/configuration/applicativeService";

// utils
const appIcons = require.context('../../../assets/images/icon/apps', true);



const AppTranslateStatisticItem = (props) => {
    const {app} = props
    const appName = app ? app.name.replace('App','').trim() : ''

    const [loadingMetrics, setLoadingMetrics] = useState(false)
    const [calculatingMetrics, setCalculatingMetrics] = useState(false)
    const [metrics, setMetrics] = useState(null)

    useEffect(() => {
        if (!app)
            return

        getMetrics()
    }, [app]);


    const getMetrics = () => {
        const requestData = {
            item: {app: app?.code}
        }

        setLoadingMetrics(true)
        applicativeService.metricsByApp(requestData)
            .then(response => {
                if(!response?.data)
                    return

                setMetrics(response?.data)
            })
            .finally(() => setLoadingMetrics(false))
    }

    const handleCalculateMetrics = (module = null ) => {
        if(calculatingMetrics)
            return showToastCustom('warning', 'Ya se está calculando las métricas')

        const requestData = {
            item: {app: app?.code}
        }

        if(module != null)
            requestData.item.module = module

        setCalculatingMetrics(true)
        applicativeService.generateMetrics(requestData)
            .then(response => {
                if(!response?.status)
                    return

                getMetrics()
            })
            .finally(() => setCalculatingMetrics(false))
    }

    const showDetails = () => {
        if (!metrics)
            return

        return ModalFormContainer(TranslateStatisticsDetails, { app, metrics, handleCalculateMetrics })
    }


    return <div className="custom-container">
        <div className={'custom-container-header'}>
            <img
                src={appIcons.keys().includes(`./${app?.code}.png`) ? appIcons(`./${app?.code}.png`) : appIcons(`./warning.svg`)}
                alt={`Icon App ${app?.code}`}
                width={40}
                height={40}
            />
            <div className={'title'}>{appName}</div>
            <GenericButton
                toolTip={LB_UPDATE_METRICS}
                style={'success-secondary'}
                icon={'fa-refresh'}
                iconLoading={'fa-refresh'}
                loading={calculatingMetrics}
                onClick={()=>handleCalculateMetrics()}
            />
        </div>
        <hr/>
        <div className={'custom-container-body'}>
            {
                loadingMetrics || calculatingMetrics
                ? <LoadingComponent title={calculatingMetrics ? LB_CALCULATING_METRICS : LB_LOADING}/>
                : <>
                    <MetricDataComponent metrics={metrics}/>
                    {
                        !loadingMetrics && !metrics && <NotInfoComponent handleCalculateMetrics={handleCalculateMetrics} />
                    }
                    <MetricGraphicComponent metrics={metrics} onClick={showDetails}/>
                </>
            }
        </div>
    </div>
}


export default AppTranslateStatisticItem;